
import { RefObject, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormInstance } from 'antd/lib/form';
import { useSelector } from 'react-redux';
import { Form } from 'antd';

import { RoomInfo } from '../room-info';

import { getNormalizedRooms, RootState, UrlUtils } from '@share/utils';
import { ROOMS_LABEL } from '@share/constants';
import { IUrlRoom } from '@common-types';

import './style.scss';

interface IProps {
  formRef: RefObject<FormInstance>;
  isCheckMainGuest: boolean;
  isRoomUnavaliableError?: boolean;
}

const GUEST_DATA: any = { adultsCount: 0, kidsAges: [], id: '1', name: 'Room #' };

export function GuestInfo(props: IProps) {
  const reviewBookStore = useSelector((state: RootState) => state.reviewBookStore);
  
  const [guests, setGuests] = useState<any[]>([]);

  const { isRoomUnavaliableError } = props;
  const { bookingSummary } = reviewBookStore;

  useEffect(() => {
    const values = UrlUtils.getValues();
    if (values[ROOMS_LABEL]) {
      const rooms = getNormalizedRooms(values[ROOMS_LABEL] as Array<IUrlRoom>);
      setGuests(rooms?.map((r, i) => ({ ...r, kidsAges: r.kids, name: `Room #${i + 1}`, id: (i + 1).toString() })));
    } else {
      setGuests([GUEST_DATA]);
    }
  }, []);

  const mainGuestData = (item: string): string => {
    const guest = reviewBookStore.guests?.find((item: any) => item.isMainGuest === true);
    return guest ? (guest[item] as string) : '';
  };

  const onFocusPhone = (): void => {
    props.formRef.current?.setFieldsValue({
      mainGuestPhone: mainGuestData('phone'),
    });
  };

  const rooms = isRoomUnavaliableError ? 
                      [...guests] : 
                      bookingSummary?.bookingCard.package.rooms || [];

  return (
    <div className="guest-info">
      <div className="guest-info__header">
        <h4 className="guest-info__title secondary-font">
          <FormattedMessage id="guest.info" />
        </h4>
        <p className="guest-info__description">
          <FormattedMessage id="guest.checking" />
        </p>
      </div>

      <Form name="guest-info-rule" ref={props.formRef}>
        {rooms.map((room: any, index: number) => (
          <RoomInfo
            key={index}
            room={room}
            indexRoom={index}
            isCheckMainGuest={props.isCheckMainGuest}
            isRoomUnavaliableError={isRoomUnavaliableError}
            onFocusPhone={onFocusPhone}
          />
        ))}
      </Form>
    </div>
  );
}
